import { render, staticRenderFns } from "./maintemplate.vue?vue&type=template&id=1fefc5be"
import script from "./maintemplate.vue?vue&type=script&lang=js"
export * from "./maintemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports